import { render } from "./ProblemUI.vue?vue&type=template&id=056755e6&ts=true"
import script from "./ProblemUI.vue?vue&type=script&lang=ts"
export * from "./ProblemUI.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__